import React from 'react';
import PropTypes from 'prop-types';
import IconSearch from '@material-ui/icons/Search';
import { TextInput, useTranslate, required } from 'react-admin';
import { useHistory } from 'react-router-dom';
import BaseDialog from './BaseDialog';
import { Form } from 'react-final-form';

const GoToEntityButton = ({ resource, buttonStyle }) => {
	const translate = useTranslate();
	const history = useHistory();

	const label = translate('coreWalletAdmin.common.labels.goToTypeButton', {
		type: translate(`resources.${resource}.name`)
	});

	const handleSubmit = (values, hideDialog) => {
		hideDialog();
		history.push(`/${resource}/${values.id}/show`);
	};

	return (
		<BaseDialog
			icon={<IconSearch />}
			buttonLabel={label}
			dialogTitle={label}
			handleSubmit={handleSubmit}
			buttonStyle={buttonStyle}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={{
						id: '',
					}}
					onSubmit={values => handleSubmit(values, hideDialog)}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<TextInput variant="standard" source="id" validate={required()} resettable fullWidth />
						</form>
					)}
				/>
			)}
		</BaseDialog>
	);
};

GoToEntityButton.propTypes = {
	resource: PropTypes.string.isRequired,
};

export default GoToEntityButton;
